import { IconProps } from "./";
import Icon from "./assets/settings_bold.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24SettingsBold(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
